import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import NP from "../../../1. Core/NP";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../../1. Core/ServerAPI";


import {Location} from "../../types";
import Select from "../../../1. Core/Controls/Select/Select";
import {getCountries} from "../../Util";
import {IState} from "../../../2. Athletes/StatesList";


export default class LocDialog extends Dialog {

	private _Date: Date;

	private _Location: Location;
	private _name: TextField;
	private _country: Select;
	private _state: TextField;
	private _city: TextField;


	_initFields(settings: object)
	{
		this._Location = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('Location');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();

		this._Date = new Date();


		this._name = new TextField({
			FloatingLabel: NP.RM.getString('Name'),
			ParentNode: this._contentNode
		});

		this._country = new Select({
			FloatingLabel: NP.RM.getString('Country'),
			ParentNode: this._contentNode
		});

		this._state = new TextField({
			FloatingLabel: NP.RM.getString('State'),
			ParentNode: this._contentNode
		});

		this._city = new TextField({
			FloatingLabel: NP.RM.getString('City'),
			ParentNode: this._contentNode
		});

		getCountries(true).then((res: IState[]) =>
		{
			let items = res.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name}));
			this._country.setItems(items);

			if (this._Location)
				this._country.setValue(this._Location.CountryId);
		})


		if (this._Location)
		{
			this._name.setValue(this._Location.Name);
			this._state.setValue(this._Location.State);
			this._city.setValue(this._Location.City);
		}

	}


	async _onOkButtonClick()
	{
		if (!this._name.getValue().trim()
			 || !this._country.getValue()
			 || !this._state.getValue().trim()
			 || !this._city.getValue().trim())
			return;

		if (!this._Location)
			this._Location = {} as Location;


		this._Location.Name = this._name.getValue().trim();
		this._Location.State = this._state.getValue().trim();
		this._Location.City = this._city.getValue().trim();
		this._Location.CountryId = this._country.getValue();


		if (this._Location.Id)
			await ServerAPI.callUiApi(`/locations/${this._Location.Id}`, this._Location, 'POST');
		else
			await ServerAPI.callUiApi("/locations", this._Location, 'PUT')


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}